// extracted by mini-css-extract-plugin
export default {"card":"RZ-z","carouselContainer":"SZ-z","carouselContent":"TZ-z"};